import Vue from 'vue'
import axios from 'axios'
import { Notify, Loading } from 'quasar'

const baseURL = process.env.VUE_APP_ACCOUNT

const http = axios.create({ baseURL })


http.interceptors.request.use((config) => {
    Loading.show()
    return config
});

http.interceptors.response.use(
    ({ data, status }) => {

        Loading.hide()
        // Check If the user is unauthorized.
        if (status === 401) {
            router.push({ name: 'login' })
            return
        }

        return data
    }, 
    ({ response, message }) => {
        Loading.hide()

        let error = response === undefined ? message : response.data.message;

        Notify.create({
			type: 'negative',
			position: 'bottom',
			message: error,
            progress: true,
            html: true
		})

        return Promise.reject(message)
    }
)

export default http